import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { convertToLocalCurrency } from "../../../utils/currency";

import checkIcon from "../../../assets/icons/check.svg";
import {
  getCampaignById,
  approveRejectCampaign,
} from "../../../redux/slices/campaignSlice";

import BackButton from "../../../components/common/BackButton";
import { Container, Details } from "./ViewCampaignStyles";

const ViewCampaign = () => {
  const dispatch = useDispatch();
  const { campaignId } = useParams();
  const userRole = localStorage.getItem('userRole');

  const { campaign, loading } = useSelector((state) => state.campaign);
  //console.log(campaign);
  useEffect(() => {
    dispatch(getCampaignById(campaignId));
  }, [dispatch, campaignId]);
  if (!campaign) {
    return <div> </div>;
  }

  const handleApproveClick = () => {
    Swal.fire({
      title: "Approve Campaign",
      html: `
        <label for="publisherCPA" style="display:block; margin-bottom:5px;">Publisher CPA</label>
        <input id="publisherCPA" type="text" class="swal2-input" placeholder="Enter Publisher CPA">
        <label for="campaignCPA" style="display:block; margin-top:15px; margin-bottom:5px;">Campaign CPA</label>
        <input id="campaignCPA" type="text" class="swal2-input" placeholder="Enter Campaign CPA">
      `,
      confirmButtonText: "Approve",
      showCancelButton: true,
      preConfirm: () => {
        const publisherCPA = document.getElementById("publisherCPA").value;
        const campaignCPA = document.getElementById("campaignCPA").value;

        if (!publisherCPA || !campaignCPA) {
          Swal.showValidationMessage("Both CPA values are required!");
          return;
        }

        return {
          state: "APPROVED",
          publisherCPA: publisherCPA,
          campaignCPA: campaignCPA,
          note: "",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        //console.log(result)
        //return
        dispatch(approveRejectCampaign({ id: campaign?.id, ...result.value }))
          .unwrap()
          .then(() => {
            dispatch(getCampaignById(campaignId));
          })
          .catch((error) => {
            console.error("Failed to approve campaign:", error);
          });
      }
    });
  };

  const handleRejectClick = () => {
    Swal.fire({
      title: "Reject Campaign",
      html: `
        <label for="reason" style="display:block; margin-bottom:5px;">Reason</label>
        <textarea id="reason" class="swal2-textarea" placeholder="Enter reason for rejection"></textarea>
      `,
      confirmButtonText: "Reject",
      showCancelButton: true,
      preConfirm: () => {
        const note = document.getElementById("reason").value;

        if (!note) {
          Swal.showValidationMessage("Reason is required!");
          return;
        }

        return {
          state: "REJECTED",
          publisherCPA: "0",
          campaignCPA: "0",
          note,
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(approveRejectCampaign({ id: campaign?.id, ...result.value }))
          .unwrap()
          .then(() => {
            dispatch(getCampaignById(campaignId));
          })
          .catch((error) => {
            console.error("Failed to reject campaign:", error);
          });
      }
    });
  };

  return (
    <Container>
      {loading ? (
        <div> </div>
      ) : (
        <>
          <div className="heading">
            <div className="texts">
              <h1>{campaign.campaignName || "N/A"}</h1>
              <p>View your team’s trades and transactions.</p>
            </div>

            <div className="link-buttons">
            <BackButton></BackButton>
              <Link className="add-campaign" to="/create-campaign">
                + Create Campaign
              </Link>
            </div>
          </div>

          <h4>Basic details</h4>
          <Details>
            <div className="wrapper" style={{ textTransform: "capitalize" }}>
              <label>Advertiser</label>
              <p>
                {campaign.user.firstName || "N/A"}{" "}
                {campaign.user.lastName || "N/A"}
              </p>
            </div>
            <hr />

            <div className="wrapper" style={{ textTransform: "capitalize" }}>
              <label>Campaign name</label>
              <p>{campaign.campaignName || "N/A"}</p>
            </div>
            <hr />

            <div className="wrapper">
              <label>Campaign url</label>
              <a
                className="url"
                href={campaign.campaignUrl || "N/A"}
                rel="noreferrer"
                target="_blank"
              >
                {campaign.campaignUrl || "N/A"}
              </a>
            </div>
          </Details>
          <hr className="outside" />

          <h4>Numbers</h4>
          <Details>
            <div className="wrapper">
              <label>Budget range</label>
              <p>{convertToLocalCurrency(campaign.campaignBudget) || "0"}</p>
            </div>
            <hr />
            <div className="wrapper">
              <label>Age range</label>
              <p>{campaign.ageRange || "0"}</p>
            </div>
            <hr />
            <div className="wrapper">
              <label>Flow</label>
              <p>{campaign.flow || "0"}</p>
            </div>
            <hr />
            <div className="wrapper">
              <label>Campaign clicks</label>
              <p>{campaign.reach || "0"}</p>
            </div>

            <hr />
            <div className="wrapper">
              <label>Conversions</label>
              <p>{campaign.acquistion || "0"}</p>
            </div>
            <hr />
            <div className="wrapper">
              <label>Conversion rate</label>
              <p>{`${campaign.conversionRate}%` || "0"}</p>
            </div>
            <hr />
            <div className="wrapper">
              <label>Cost per acquisition(CPA)</label>
              <p>{campaign.costPerUser || "0"}</p>
            </div>
          </Details>
          <hr className="outside" />

          <h4>Objective and location</h4>
          <Details>
            <div className="wrapper">
              <label>Campaign objective</label>
              <p>{campaign.campaignObjective || "N/A"}</p>
            </div>
            <hr />

            <div className="wrapper">
              <label>Carrier</label>
              <p>{campaign.carrier || "N/A"}</p>
            </div>
            <hr />

            <div className="wrapper">
              <label>Geo</label>
              <p>{campaign.location || "N/A"}</p>
            </div>
          </Details>
          <hr className="outside" />

          <h4>Preferences</h4>
          <Details>
            <div className="wrapper" style={{ textTransform: "capitalize" }}>
              <label>Gender</label>
              <p>{campaign.gender || "N/A"}</p>
            </div>
            <hr />

            <div className="wrapper" style={{ textTransform: "capitalize" }}>
              <label>Interest</label>
              <p>{campaign.interest ? campaign.interest.join(", ") : "N/A"}</p>
            </div>
          </Details>
          <hr className="outside" />

          <h4>Image</h4>
          <Details>
            {campaign.photoUrl && campaign.photoUrl[0] ? (
              <img
                className="img"
                src={campaign.photoUrl[0].url}
                alt="campaign-img"
              />
            ) : (
              <p>No image available</p>
            )}
          </Details>
          <hr className="outside" />

          <h4>Status</h4>
          <Details>
            <div className="wrapper">
              <label>Pending</label>
              {campaign?.isApproved === "PENDING" ? (
                <img src={checkIcon} alt="check" />
              ) : null}
            </div>
            <hr />
            <div className="wrapper">
              <label>Approved</label>
              {campaign?.isApproved === "APPROVED" ? (
                <img src={checkIcon} alt="check" />
              ) : null}
            </div>
            <hr />
            <div className="wrapper">
              <label>Rejected</label>
              {campaign?.isApproved === "REJECTED" ? (
                <img src={checkIcon} alt="check" />
              ) : null}
            </div>
          </Details>
          <hr className="outside" />

          {userRole === 'SUPPORT' ? '' : (
          <div className="approval">
            <div></div>
            <div className="link-buttons">
              <button
                className="see-more"
                onClick={handleRejectClick}
                disabled={campaign?.isApproved !== "PENDING"}
              >
                Reject
              </button>
              <button
                className="add-campaign"
                onClick={handleApproveClick}
                disabled={campaign?.isApproved === "APPROVED"}
              >
                Approve
              </button>
            </div>
          </div>
          )}
        </>
      )}
    </Container>
  );
};

export default ViewCampaign;
